module.exports = __webpack_public_path__ + "static/envato-4ba43cebd4bd90a87169dc3c85c28e76.jpg";